import React from "react";
import { Link, useLocation } from "../components/Router";
import { Helmet } from "react-helmet";
import log from 'loglevel';
import "../sass/bread-crumb-trail.scss";
import { CLOUD_FRONT_ABSOLUTE_ENDPOINT } from "api-config";

const getBreadCrumbAttributes = ({ i, pathComponent, subComponents, active }) => {
  if (i === 0) {
    return {
      name: "home",
      href: "/",
      active,
    };
  }
  if (i === 4 && subComponents.length >= 2 && subComponents[1] === "e") {
    // All caps for the ticker symbol
    return {
      name: pathComponent.toUpperCase(),
      href: subComponents.join("/"),
      active,
    };
  }
  return {
    name: pathComponent,
    href: subComponents.join("/"),
    active,
  };
};

const PathComponentCrumb = ({ name, href, active }) => {

  const activeClass = active ? "active" : "";
  const ariaCurrent = active ? "page" : null;

  // https://getbootstrap.com/docs/4.6/components/breadcrumb/
  return (
    <>
      <li
        className={`breadcrumb-item ${activeClass}`}
        aria-current={ariaCurrent}
      >
        {active ? <>{name}</> : <Link to={href}>{name}</Link>}
      </li>
    </>
  );
};

const filterOutPathComponents = (pathComponents) => {

  return pathComponents.filter(pathComponent => {
    const { i, subComponents } = pathComponent;
    if (i >= 1 && subComponents[1] === "e") {
      if ([1, 2, 3, 5, 6, 7].includes(i)) {
        // Omit path components that don't have real pages
        return false;
      }
    }
    return true;
  });
};

const getPathComponents = (pathname) => {
  const pathComponents = pathname.split("/");
  if (pathComponents.length > 2 && pathComponents[1] === "calendar") {
    return [
      "", "calendar", pathComponents.slice(2).join("-")
    ];
  }
  return pathComponents;
};

const BreadCrumbsStructuredData = ({ breadCrumbs }) => {

  const breadcrumbList = breadCrumbs.map(( breadCrumb, i ) => {
    // log.trace("StructuredData breadCrumb", breadCrumb);
    const { name, href } = breadCrumb;
    const fullUrl = `${CLOUD_FRONT_ABSOLUTE_ENDPOINT}${href}`
    return {
      "@type": "ListItem",
      position: i + 1,
      item: {
        "@id": fullUrl,
        name,
      }
    };
  });
  // log.trace("StructuredData", breadcrumbList);
  const data = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: breadcrumbList,
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          { JSON.stringify(data) }
        </script>
      </Helmet>
    </>
  );

};

const BreadCrumbTrail = ({ disableBreadCrumb }) => {
  const { pathname } = useLocation();

  if (disableBreadCrumb) {
    return <></>;
  }

  const pathComponents = getPathComponents(pathname);
  const componentPropsList = filterOutPathComponents(pathComponents.map((pathComponent, i) => {
    const subComponents = pathComponents.slice(0, i + 1);
    return {
      key: i,
      i,
      pathComponent,
      pathname,
      subComponents,
      active: subComponents.length === pathComponents.length,
    };
  }));
  const breadCrumbs = componentPropsList.map(component => getBreadCrumbAttributes(component));

  // https://getbootstrap.com/docs/4.6/components/breadcrumb/
  return (
    <>
      <BreadCrumbsStructuredData breadCrumbs={breadCrumbs} />
      <nav className="bread-crumb-trail" aria-label="breadcrumb">
        <div className="container">
          <ol className="breadcrumb">
            { breadCrumbs.map((breadCrumb, i) => (
              <PathComponentCrumb key={i} {...breadCrumb} />
            )) }
          </ol>
        </div>
      </nav>
    </>
  );
};

export default BreadCrumbTrail;
